import { Application } from '@inmotionnow/momentum-components-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentTitle } from '@/components/document-title'
import { ExperimentalFeatureBanner } from '@/components/experimental-feature-banner'

interface IAppLayoutProps {
  documentTitle?: string
  nav?: React.ReactNode
  view: React.ReactNode
}

export type { IAppLayoutProps }

export const AppLayout = (props: IAppLayoutProps) => {
  const { t } = useTranslation()
  return (
    <Application.Layout>
      {props.documentTitle && (
        <DocumentTitle {...{ title: t(props.documentTitle) }} />
      )}
      {props.nav}
      <ExperimentalFeatureBanner />
      {props.view}
    </Application.Layout>
  )
}
